import React from 'react';

export default function AdminMatchScore({ fixture, matchDay, time, scores, hideOutsideLookupWindow = false, hideDisclaimer = false }) {
  const kickoff = Date.parse(`${matchDay}T${time}Z`);
  const key = JSON.stringify([matchDay, time, fixture]);
  const result = scores?.results?.[key];
  const checkedAt = scores?.checkedAtByMatch?.[key];
  let message;
  if (kickoff > Date.now()) message = 'Awaiting result — match has not started.';
  else if (kickoff < Date.now() - 3 * 86400000) message = 'Result unavailable — outside the API’s three-day lookup window.';
  else if (!scores || scores.loading) message = 'Loading API result…';
  else if (scores.error) message = scores.error;
  else message = result?.message || 'No matching result returned by The Odds API.';

  const hasScore = result && ['completed', 'in_progress'].includes(result.status) && !scores?.loading && !scores?.error;
  if (hideOutsideLookupWindow && !hasScore && kickoff < Date.now() - 3 * 86400000) return null;
  return <div className='text-white text-start my-2 font-12' role='status'>
    <strong>The Odds API: </strong>
    {hasScore ? <>
      <span className='text-orange fw-bold'>{result.homeTeam} {result.homeScore} – {result.awayScore} {result.awayTeam}</span>
      <span> · {result.status === 'completed' ? 'Completed' : 'In progress / not final'}</span>
      {!hideDisclaimer && <div>Reported score only; 90-minute / extra-time / penalty breakdown is not supplied. Does not settle bets.</div>}
      {checkedAt && <div>Checked: {new Date(checkedAt).toLocaleString()}</div>}
    </> : <span>{message}</span>}
  </div>;
}
